/* @flow */

import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { parseParams } from "helpers/location-search-string";
import useCookie from "helpers//hooks/use-cookie";
import Loading from "pages/Loading";

const RetrackRedirect = (): React$Node => {
  const location = useLocation();
  const { replace } = useHistory();
  const { click, deeplink } = parseParams(location.search);
  const [eventId, setEventId, eventIdRead] = useCookie("retrackEvent", "", { expires: 10 });
  useEffect(() => {
    if (click && typeof click === "string") {
      setEventId(click);
    }
  }, [click, eventIdRead]);

  useEffect(() => {
    if (!eventIdRead) {
      return;
    }

    if (eventId && deeplink && typeof deeplink === "string") {
      try {
        const decoded = decodeURIComponent(deeplink);
        const path = decoded.replace(/^https?:\/\/[^/]+/, "");
        const url = new URL(path, window.location.origin);

        replace(url.pathname + url.search);
        return;
      }
      catch (e) {
        console.error("Invalid deeplink:", e);
      }
    }

    replace("/");
  }, [eventId, eventIdRead, deeplink, replace]);

  return <Loading />;
};

export default RetrackRedirect;
